import { render, staticRenderFns } from "./AccountingNotesDescriptions.vue?vue&type=template&id=647b7dc2&scoped=true&"
import script from "./AccountingNotesDescriptions.vue?vue&type=script&lang=js&"
export * from "./AccountingNotesDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./AccountingNotesDescriptions.vue?vue&type=style&index=0&id=647b7dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b7dc2",
  null
  
)

export default component.exports